<script setup>
import { fechaTexto, cantidadSalidas } from './fecha'

defineProps({
  conductor: { type: Object, required: true },
})

defineEmits(['informar', 'cambiar-conductor'])

const territoriosTexto = (salida) => salida.territorios.map((t) => t.key).join(', ')
</script>

<template>
  <div class="mayores-contenido">
    <p class="mayores-saludo">Hola, {{ conductor.name }}</p>

    <template v-if="conductor.salidas.length">
      <p class="campo__ayuda" style="margin-top:0">
        Tenés {{ cantidadSalidas(conductor.salidas.length) }}. Tocá una para contar qué territorios se trabajaron.
      </p>

      <div
        v-for="s in conductor.salidas"
        :key="s.id"
        class="tarjeta-lista tarjeta-lista--clickable"
        role="button"
        tabindex="0"
        @click="$emit('informar', s.id)"
        @keydown.enter="$emit('informar', s.id)"
      >
        <p class="tarjeta-lista__titulo">{{ fechaTexto(s.date) }}</p>
        <p v-if="s.hour" class="tarjeta-lista__detalle">
          <i class="pi pi-clock" aria-hidden="true" /> {{ s.hour }} hs
        </p>
        <p v-if="s.puntoEncuentro" class="tarjeta-lista__detalle">
          <i class="pi pi-map-marker" aria-hidden="true" /> {{ s.puntoEncuentro }}
        </p>
        <p v-if="s.grupos.length" class="tarjeta-lista__detalle">
          <i class="pi pi-users" aria-hidden="true" /> Grupo{{ s.grupos.length !== 1 ? 's' : '' }}: {{ s.grupos.join(', ') }}
        </p>
        <p class="tarjeta-lista__detalle">
          <i class="pi pi-th-large" aria-hidden="true" />
          Territorio{{ s.territorios.length !== 1 ? 's' : '' }}: {{ territoriosTexto(s) }}
        </p>
        <button type="button" class="boton-primario" @click.stop="$emit('informar', s.id)">
          <i class="pi pi-pencil" aria-hidden="true" /> Informar esta salida
        </button>
      </div>
    </template>

    <div v-else class="tarjeta-accion mayores-exito mayores-exito-panel">
      <i class="pi pi-check-circle" aria-hidden="true" />
      <h2>¡Todo al día!</h2>
      <p>No tenés salidas pendientes de informar.</p>
    </div>

    <button type="button" class="boton-secundario mayores-separacion" @click="$emit('cambiar-conductor')">
      <i class="pi pi-user" aria-hidden="true" /> No soy {{ conductor.name }}
    </button>
  </div>
</template>
